<template>
    <form @submit.prevent="submitUser">
        <div class="invite-modal__lockable-section">
            <div class="invite-modal__row">
                <label class="invite-modal__form-control invite-modal__form-control_full-size">
                    <span class="invite-modal__label">Email</span>
                    <input type="text" 
                        class="invite-modal__field"
                        :class="{'invite-modal__field_invalid': isEmailInvalid}"
                        :readonly="isExisting"
                        @input="emailChanged = true"
                        placeholder="Email"
                        v-model="email" />
                    <span v-if="isEmailInvalid"
                        class="invite-modal__error">{{ emptyFieldValidationMessage }}</span>
                </label>
            </div>
            <div class="invite-modal__row">
                <label class="invite-modal__form-control invite-modal__form-control_half-size">
                    <span class="invite-modal__label">First Name</span>
                    <input type="text" 
                        class="invite-modal__field"
                        :class="{'invite-modal__field_invalid': isFirstNameInvalid}"
                        :readonly="isExisting"
                        @input="firstNameChanged = true"
                        placeholder="First Name"
                        v-model="firstName" />
                    <span v-if="isFirstNameInvalid"
                        class="invite-modal__error">{{ emptyFieldValidationMessage }}</span>
                </label>
                <label class="invite-modal__form-control invite-modal__form-control_half-size">
                    <span class="invite-modal__label">Last Name</span>
                    <input type="text" 
                        class="invite-modal__field"
                        :class="{'invite-modal__field_invalid': isLastNameInvalid}"
                        :readonly="isExisting"
                        @input="lastNameChanged = true"
                        placeholder="Last Name"
                        v-model="lastName" />
                    <span v-if="isLastNameInvalid"
                        class="invite-modal__error">{{ emptyFieldValidationMessage }}</span>
                </label>
            </div>
            <p v-if="isExisting"
                class="invite-modal__text">This person is already a member of this project. You can update their role here if you want.</p>
            <div class="invite-modal__row">
                <label class="invite-modal__form-control invite-modal__form-control_full-size">
                    <span class="invite-modal__label">User Role</span>
                    <base-select :options="availableRoles"
                        class="invite-modal__select"
                        placeholder="User Role"
                        :class="{'invite-modal__select_invalid': isRoleIdInvalid}"
                        v-model="roleId" />
                    <span v-if="isRoleIdInvalid"
                        class="invite-modal__error">Please select User Role</span>
                </label>
            </div>
            <div v-if="isUserInviting"
                class="invite-modal__loader">
                <base-loader />
            </div>
        </div>
        <div class="invite-modal__controls">
            <button type="button"
                @click="cancel"
                class="invite-modal__button">Cancel</button>
            <button type="button"
                @click="back"
                :disabled="isUserInviting"
                class="invite-modal__button">Back</button>
            <button type="submit"
                :disabled="isUserInviting"
                class="invite-modal__button invite-modal__button_submit">Invite</button>
        </div>
    </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: 'InviteUserPopupStep2',
    data() {
        return {
            email: '',
            firstName: '',
            lastName: '',
            roleId: null,
            emptyFieldValidationMessage: 'This field can\'t be empty',
            emailChanged: false,
            firstNameChanged: false,
            lastNameChanged: false,
            isRoleIdInvalid: false,
        }
    },
    props: {
        userData: Object,
        isExisting: Boolean,
        availableRoles: Array
    },
    mounted() {
        const { email, firstName, lastName, roleId } = this.userData
        this.email = email
        this.firstName = firstName
        this.lastName = lastName
        this.roleId = roleId
    },
    computed: {
        ...mapState('users', [
            'isUserInviting'
        ]),
        isEmailInvalid() {
            return this.emailChanged && !this.email
        },
        isFirstNameInvalid() {
            return this.firstNameChanged && !this.firstName
        },
        isLastNameInvalid() {
            return this.lastNameChanged && !this.lastName
        },
        hasErrors() {
            return this.isEmailInvalid || this.isFirstNameInvalid || this.isLastNameInvalid || this.isRoleIdInvalid
        },
        isSomethingMissing() {
            return !this.email || !this.firstName || !this.lastName || !this.roleId
        }
    },
    watch: {
        roleId() {
            this.isRoleIdInvalid = false
        }
    },
    methods: {
        ...mapActions('users', [
            'inviteNewUser',
            'inviteExistingUser'
        ]),
        async submitUser() {
            this.emailChanged = true
            this.firstNameChanged = true
            this.lastNameChanged = true
            if (!this.roleId) {
                this.isRoleIdInvalid = true
                return
            }
            if (this.isExisting) {
                const userData = {
                    id: this.userData.userId,
                    roleId: this.roleId
                }

                await this.inviteExistingUser({ ...userData, clientId: this.clientId })
            } else {
                const userData = {
                    email: this.email,
                    firstName: this.firstName,
                    lastName: this.lastName,
                    roleId: this.roleId
                }

                await this.inviteNewUser({ ...userData, clientId: this.clientId })
            }

            this.cancel()
        },
        cancel() {
            this.$emit('cancel')
        },
        back() {
            this.$emit('back')
        }
    }
}
</script>

<style scoped lang="scss">
    .invite-modal {
        &__lockable-section {
            position: relative;
        }

        &__loader {
            bottom: 10px !important;
        }
    }
</style>